<template>
  <div>
    <search-agent-transfers @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button
          type="primary"
          @click="showNewModal"
          v-if="isShowNewMenu()"
        >记录收付款</a-button>
        <a-button type="primary" @click="exportData">导出</a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
    >
      <img
        slot="payorderpic"
        slot-scope="text, record"
        v-if="record.pay_order_url"
        :src="record.pay_order_url"
        style="width:50px;"
        alt=""
        @click="handlePreview(record.pay_order_url)"
      >
    </a-table>

    <!-- 记录收付款模态框 -->
    <new-agent-transfer
      v-if="isShowNewModal"
      :visible.sync="isShowNewModal"
      @completed="fetchData"
    />

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <preview-image
      :visible.sync="previewVisible"
      :image.sync="previewImage"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import SearchAgentTransfers from '@/views/transfers/agent/Search'
import PreviewImage from '@/components/PreviewImage'
import { hasPermission } from '@/utils/permission'
import NewAgentTransfer from '@/views/transfers/agent/New'
import { findAgentTransfers, exportAgentTransfers } from '@/api/transfer'
import { getOriginalUserUid } from '@/utils/token'
import { formatCurrency } from '@/utils/filter'
import { exportExcel } from '@/api/excel'

export default {
  name: 'AgentTransferList',
  components: {
    NewAgentTransfer,
    SearchAgentTransfers,
    PreviewImage,
    Pagination
  },
  data() {
    return {
      data: [],
      loading: true,
      isShowNewModal: false,
      previewVisible: false,
      previewImage: '',
      pagination: {
        total_count: 0
      },
      query: {
      }
    }
  },
  computed: {
    agentId() {
      return parseInt(this.$route.params.id)
    },

    columns() {
      return [
        {
          title: '事件批次',
          width: 100,
          dataIndex: 'no'
        },
        {
          title: '收付款日期',
          width: 120,
          dataIndex: 'paid_at'
        },
        {
          title: '收付款类型',
          width: 100,
          dataIndex: 'transfer_type'
        },
        {
          title: '金额(元)',
          width: 100,
          customRender: formatCurrency,
          dataIndex: 'amount'
        },
        {
          title: '支付方式',
          width: 100,
          dataIndex: 'pay_way'
        },
        {
          title: '支付凭据',
          width: 100,
          dataIndex: 'pay_order_url',
          scopedSlots: { customRender: 'payorderpic' }
        },
        {
          title: '备注',
          ellipsis: true,
          width: 200,
          dataIndex: 'remark'
        },
        {
          title: '记录时间',
          width: 180,
          dataIndex: 'created_at'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },

    isShowNewMenu() {
      // 有权限 && 不是超级登录
      return this.isShowMenu('agents/transfers/new') && !getOriginalUserUid()
    },

    showNewModal() {
      this.isShowNewModal = true
    },

    submitSearch(search) {
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findAgentTransfers(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    },

    handlePreview(imageURL) {
      this.previewImage = imageURL
      this.previewVisible = true
    },

    exportData() {
      exportAgentTransfers(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        if (res.code === 0 && res.data.is_direct_download === true) {
          exportExcel(res.data.id, res.data.file_name)
        }
      })
    }
  }
}
</script>

